import styled from '@emotion/styled';
import { useTranslation, LanguageSelector } from '@hotjar/translations';
import { useCurrentUser } from '@hotjar/user';
// import { useTrack } from '@hotjar/webapp/hooks/useTrack';

import { PageHeader, Text, tokens } from '@hotjar/hotsauce';
import { isAllowed } from '@hotjar/feature-flags';

export const Page = styled.article`
  padding: ${tokens.spacer.x3} ${tokens.spacer.x4};
`;

const DropdownBox = styled.div`
  width: 280px;
  margin-top: ${tokens.spacer.x2};
`;

export const ProfileLanguage = (): JSX.Element => {
  const { t } = useTranslation('profile');
  const { data: currentUser } = useCurrentUser();
  // const { click: trackClick } = useTrack();
  const shouldUseLocalizationDevMode = isAllowed('localization-dev-mode', null);

  const trackLanguageChanged = () => {
    // todo tracking
  };

  return (
    <Page>
      <PageHeader title={t('language.page-title')} />
      <Text textType="body2">{t('language.description')}</Text>
      <DropdownBox>
        <LanguageSelector
          shouldUseLocalizationDevMode={shouldUseLocalizationDevMode}
          onClick={trackLanguageChanged}
          kind="select"
          userId={currentUser?.id}
        />
      </DropdownBox>
    </Page>
  );
};
